import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Skeleton } from '@uhg-abyss/web/ui/Skeleton';
import { useLocation } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';

const Value = styled('div', {
  color: '$gray8',
  fontSize: '16px',
  lineHeight: '22px',
  fontWeight: 700,
  fontStyle: 'normal',
  marginTop: '2.3%',
  wordWrap: 'break-word',
  marginBottom: '30px',
});

const Section = styled('div', {
  marginBottom: 10,
  '&:last-child': {
    marginBottom: 0,
  },
});

const Name = styled('div', {
  color: '$gray8',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '22px',
});

export const SecondaryServicing = ({ index, address, isLoading }) => {
  const addressData = address?.secondaryServicing?.[index];
  const location = useLocation();
  const isFinalStep = location.pathname.includes('/step/4');
  const fileNameStyle = {
    fontWeight: 600,
    wordWrap: 'break-word',
    color: isFinalStep ? 'rgb(25, 110, 207)' : 'rgb(51,51,51)',
  };
  return (
    <React.Fragment>
      <Section>
        <Value>
          {isLoading ? (
            <Skeleton variant="rounded" height={20} width={200} />
          ) : (
            <div style={{ marginBottom: '-22px' }}>
              <p
                id={`address-secondary-servicing-${index}-street-line-1`}
                style={{ marginBottom: '1px' }}
              >
                {addressData?.streetLine1 || '-'}
                <br />
              </p>
              {addressData?.streetLine2 && (
                <div
                  id={`address-secondary-servicing-${index}-street-line-2`}
                  style={{ marginBottom: '-22px' }}
                >
                  {addressData.streetLine2} <br />
                </div>
              )}
              <br />
              <div
                style={{
                  display: 'inline-block',
                  overflowWrap: 'break-word',
                  width: '100%',
                }}
              >
                <p
                  id={`address-secondary-servicing-${index}-city`}
                  style={{ display: 'inline-block', marginBottom: '1px' }}
                >
                  {addressData?.city || '-'}
                </p>
                {', '}
                <div
                  id={`address-secondary-servicing-${index}-state`}
                  style={{ display: 'inline-block' }}
                >
                  {addressData?.state || '-'}
                </div>
                <div
                  id={`address-secondary-servicing-${index}-zip-code`}
                  style={{ display: 'inline-block', marginLeft: '4px' }}
                >
                  {addressData?.zipCode || '-'}
                </div>
              </div>
            </div>
          )}
        </Value>
      </Section>
      <Section>
        <Name>Servicing Address Proof</Name>
        <div
          id={`address-secondary-servicing-${index}-file-attachment`}
          style={fileNameStyle}
        >
          {isLoading ? (
            <Skeleton variant="rounded" height={20} width={200} />
          ) : (
            <div>{addressData?.proof?.name || '-'}</div>
          )}
        </div>
      </Section>
    </React.Fragment>
  );
};

SecondaryServicing.propTypes = {
  index: PropTypes.number.isRequired,
  address: PropTypes.shape({
    secondaryServicing: PropTypes.arrayOf(
      PropTypes.shape({
        streetLine1: PropTypes.string,
        streetLine2: PropTypes.string,
        state: PropTypes.shape({ value: PropTypes.string }),
        city: PropTypes.string,
        zipCode: PropTypes.string,
        proof: PropTypes.shape({ name: PropTypes.string }),
      })
    ),
  }),
  isLoading: PropTypes.bool,
};

SecondaryServicing.defaultProps = {
  address: { secondaryServicing: [] },
  isLoading: false,
};
